import React from 'react';
import {Box, Chip, Typography} from "@mui/joy";

interface Props {
    name: string;
    role?: string | null;
    roleTestId?: string;
    /** Further chips after the role (e.g. "Linked"). */
    children?: React.ReactNode;
}

/**
 * A contact's name with its role chip right behind it — the single name row of
 * every contact surface (node contact tab cards, service center box, dashboard
 * hero cards). The row wraps, so the chip only drops below the name when the
 * column is too narrow; minHeight keeps rows with and without a role aligned.
 */
const ContactNameRow = ({name, role, roleTestId, children}: Props) => (
    <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap: '8px', rowGap: '4px', minHeight: '24px', minWidth: 0}}>
        <Typography level="bodyBold" noWrap sx={{color: '#333', maxWidth: '100%'}}>
            {name}
        </Typography>
        {role && (
            <Chip size="sm" color="neutral" variant="soft" data-testid={roleTestId} sx={{maxWidth: '100%'}}>
                {role}
            </Chip>
        )}
        {children}
    </Box>
);

export default ContactNameRow;
